import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, Button, TextField } from '@mui/material';
import './AgeVerification.css';

const AgeVerification = () => {
  const [open, setOpen] = useState(false);
  const [birthDate, setBirthDate] = useState('2025-01-01');
  const [error, setError] = useState('');
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    const ageVerified = getCookie('ageVerified');
    if (ageVerified === 'true') {
      setOpen(false);
    } else if (ageVerified === 'false') {
      setBlocked(true);
      setOpen(true);
    } else {
      setOpen(true);
    }
  }, []);

  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  };

  const setCookie = (name, value, days) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
  };

  const calculateAge = (dob) => {
    const today = new Date();
    const birth = new Date(dob);
    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    return age;
  };

  const handleSubmit = () => {
    const age = calculateAge(birthDate);
    if (isNaN(age)) {
      setError('Please enter a valid date.');
    } else if (age >= 18) {
      setCookie('ageVerified', 'true', 365);
      setOpen(false);
    } else {
      setCookie('ageVerified', 'false', 365);
      setBlocked(true);
      setError('');
    }
  };

  return (
    <Modal open={open} onClose={() => {}} disableEscapeKeyDown>
      <Box className="age-modal-box">
        <h3 style={{fontSize: 14, fontWeight: 600, color: '#000000' }}>
          {blocked ? 'Access Denied' : 'Before we get started let’s verify your age.'}
        </h3>
        <Typography
          variant="body2"
          gutterBottom
          align="center"
          color={blocked ? 'error' : 'textPrimary'}
        >
          {blocked
            ? 'You must be 18+ to enter the site.'
            : ''}
        </Typography>

        {!blocked && (
          <>
            <TextField
              type="date"
              value={birthDate}
              onChange={(e) => {
                setBirthDate(e.target.value);
                setError('');
              }}
              inputProps={{ style: { textAlign: 'center' } }}
              sx={{
                width: '220px',
                margin: '16px auto',
                display: 'block',
              }}
            />
            {error && (
              <Typography color="error" variant="body2" align="center">
                {error}
              </Typography>
            )}
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              sx={{
                borderRadius: '999px',
                marginTop: '16px',
                padding: '10px 24px',
                width: '160px',
                display: 'block',
                marginLeft: 'auto',
                marginRight: 'auto',
                boxShadow: 'none'
              }}
            >
              Submit
            </Button>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default AgeVerification;
